import * as React from 'react';
import { Translate } from 'react-jhipster';
import { Row, Col } from 'reactstrap';

export class Opportunity extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <Row className="justify-content-center">
        <Col md="8" className="bg-white">
          <Row className="justify-content-center">
            <Col md="8" className="m-3">
              <h1>
                <Translate contentKey="static.opportunity.title">合作機會</Translate>
              </h1>
              <p>
                <Translate contentKey="static.opportunity.text1">
                  如想透過PATO ENTERTAINMENT銷售門票，歡迎提供以下資料電郵與我們查詢<a href="mailto:info@patotix.com">info@patotix.com</a>",
                </Translate>
              </p>
              <ul>
                <li>
                  <Translate contentKey="static.opportunity.p1">公司名稱</Translate>
                </li>
                <li>
                  <Translate contentKey="static.opportunity.p2">姓名</Translate>
                </li>
                <li>
                  <Translate contentKey="static.opportunity.p3">電郵地址</Translate>
                </li>
                <li>
                  <Translate contentKey="static.opportunity.p4">聯絡電話</Translate>
                </li>
                <li>
                  <Translate contentKey="static.opportunity.p5">節目名稱</Translate>
                </li>
                <li>
                  <Translate contentKey="static.opportunity.p6">演出場館</Translate>
                </li>
                <li>
                  <Translate contentKey="static.opportunity.p7">演出日期</Translate>
                </li>
              </ul>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default Opportunity;
